// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.poll-widget {
  margin: 14px 0 8px 0;
  padding: 16px;
  background: var(--bg-secondary, rgba(255, 255, 255, 0.04));
  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.1));
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.poll-question-header {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.poll-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 2px 8px;
  border-radius: 999px;
  background: var(--accent-color-dim, rgba(227, 19, 55, 0.15));
  color: var(--accent-color, #e31337);
  flex-shrink: 0;
  margin-top: 2px;
}

.poll-question {
  font-size: 1.05rem;
  font-weight: 600;
  color: var(--text-primary, #ffffff);
  line-height: 1.35;
  margin: 0;
}

.poll-choices-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* Option container */
.poll-choice-item {
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.12));
  background: var(--bg-tertiary, rgba(255, 255, 255, 0.02));
  min-height: 42px;
  display: flex;
  align-items: center;
  transition: border-color 0.15s ease, background 0.15s ease;
}

.poll-choice-item.interactive {
  cursor: pointer;
}

.poll-choice-item.interactive:hover {
  border-color: var(--accent-color, #e31337);
  background: rgba(227, 19, 55, 0.05);
}

.poll-choice-item.selected {
  border-color: var(--accent-color, #e31337);
  background: rgba(227, 19, 55, 0.08);
}

.poll-choice-item.voted-user {
  border-color: var(--accent-color, #e31337);
}

/* Progress bar inside choice */
.poll-choice-bar {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  background: var(--accent-color-dim, rgba(227, 19, 55, 0.22));
  border-radius: 7px;
  transition: width 0.35s ease;
  z-index: 1;
}

.poll-choice-content {
  position: relative;
  z-index: 2;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  gap: 12px;
}

.poll-choice-left {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 500;
  color: var(--text-primary, #ffffff);
  word-break: break-word;
}

.poll-choice-input {
  accent-color: var(--accent-color, #e31337);
  cursor: pointer;
}

.poll-voted-check {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: var(--accent-color, #e31337);
  color: #fff;
  font-size: 11px;
  font-weight: bold;
}

.poll-choice-right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  font-size: 0.9rem;
}

.poll-choice-percent {
  font-weight: 700;
  color: var(--text-primary, #ffffff);
}

.poll-choice-votes {
  font-size: 0.8rem;
  color: var(--text-secondary, #a0a0a0);
}

.poll-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 4px;
  padding-top: 8px;
  border-top: 1px solid var(--border-color, rgba(255, 255, 255, 0.08));
  font-size: 0.85rem;
  color: var(--text-secondary, #a0a0a0);
}

.poll-meta-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.poll-vote-btn {
  padding: 7px 18px;
  font-size: 0.88rem;
  font-weight: 600;
  border-radius: 999px;
  border: none;
  background: var(--accent-color, #e31337);
  color: #ffffff;
  cursor: pointer;
  transition: opacity 0.15s ease, transform 0.1s ease;
}

.poll-vote-btn:hover:not(:disabled) {
  opacity: 0.9;
  transform: translateY(-1px);
}

.poll-vote-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.poll-error-msg {
  color: #ff5c5c;
  font-size: 0.85rem;
  margin-top: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/components/PollWidget/PollWidget.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,aAAa;EACb,0DAA0D;EAC1D,+DAA+D;EAC/D,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,4DAA4D;EAC5D,mCAAmC;EACnC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gEAAgE;EAChE,yDAAyD;EACzD,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,0DAA0D;AAC5D;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,mCAAmC;AACrC;;AAEA;EACE,0CAA0C;EAC1C,mCAAmC;AACrC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,SAAS;EACT,4DAA4D;EAC5D,kBAAkB;EAClB,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,oEAAoE;EACpE,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,wCAAwC;EACxC,cAAc;EACd,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":[".poll-widget {\n  margin: 14px 0 8px 0;\n  padding: 16px;\n  background: var(--bg-secondary, rgba(255, 255, 255, 0.04));\n  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.1));\n  border-radius: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.poll-question-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n}\n\n.poll-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 0.72rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  padding: 2px 8px;\n  border-radius: 999px;\n  background: var(--accent-color-dim, rgba(227, 19, 55, 0.15));\n  color: var(--accent-color, #e31337);\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.poll-question {\n  font-size: 1.05rem;\n  font-weight: 600;\n  color: var(--text-primary, #ffffff);\n  line-height: 1.35;\n  margin: 0;\n}\n\n.poll-choices-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n/* Option container */\n.poll-choice-item {\n  position: relative;\n  overflow: hidden;\n  border-radius: 8px;\n  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.12));\n  background: var(--bg-tertiary, rgba(255, 255, 255, 0.02));\n  min-height: 42px;\n  display: flex;\n  align-items: center;\n  transition: border-color 0.15s ease, background 0.15s ease;\n}\n\n.poll-choice-item.interactive {\n  cursor: pointer;\n}\n\n.poll-choice-item.interactive:hover {\n  border-color: var(--accent-color, #e31337);\n  background: rgba(227, 19, 55, 0.05);\n}\n\n.poll-choice-item.selected {\n  border-color: var(--accent-color, #e31337);\n  background: rgba(227, 19, 55, 0.08);\n}\n\n.poll-choice-item.voted-user {\n  border-color: var(--accent-color, #e31337);\n}\n\n/* Progress bar inside choice */\n.poll-choice-bar {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  background: var(--accent-color-dim, rgba(227, 19, 55, 0.22));\n  border-radius: 7px;\n  transition: width 0.35s ease;\n  z-index: 1;\n}\n\n.poll-choice-content {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 14px;\n  gap: 12px;\n}\n\n.poll-choice-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-weight: 500;\n  color: var(--text-primary, #ffffff);\n  word-break: break-word;\n}\n\n.poll-choice-input {\n  accent-color: var(--accent-color, #e31337);\n  cursor: pointer;\n}\n\n.poll-voted-check {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: var(--accent-color, #e31337);\n  color: #fff;\n  font-size: 11px;\n  font-weight: bold;\n}\n\n.poll-choice-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  font-size: 0.9rem;\n}\n\n.poll-choice-percent {\n  font-weight: 700;\n  color: var(--text-primary, #ffffff);\n}\n\n.poll-choice-votes {\n  font-size: 0.8rem;\n  color: var(--text-secondary, #a0a0a0);\n}\n\n.poll-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 4px;\n  padding-top: 8px;\n  border-top: 1px solid var(--border-color, rgba(255, 255, 255, 0.08));\n  font-size: 0.85rem;\n  color: var(--text-secondary, #a0a0a0);\n}\n\n.poll-meta-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.poll-vote-btn {\n  padding: 7px 18px;\n  font-size: 0.88rem;\n  font-weight: 600;\n  border-radius: 999px;\n  border: none;\n  background: var(--accent-color, #e31337);\n  color: #ffffff;\n  cursor: pointer;\n  transition: opacity 0.15s ease, transform 0.1s ease;\n}\n\n.poll-vote-btn:hover:not(:disabled) {\n  opacity: 0.9;\n  transform: translateY(-1px);\n}\n\n.poll-vote-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.poll-error-msg {\n  color: #ff5c5c;\n  font-size: 0.85rem;\n  margin-top: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
